import { Box, Button, CircularProgress, FormControl, InputLabel, Stack, TextareaAutosize, Typography } from "@mui/material";
import React, { useContext, useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";
import policyService from "../services/policyService";
import { contentBoxStyle, ThemeModeContext } from "../shared/Theme";
import { format } from "date-fns";
import alertService from "../services/alertService";

const PolicyAudit = () => {

	let [ policy, setPolicy ] = useState(null);
	let [ usecurePolicyData, setUsecurePolicyData ] = useState(null);
	let [ audit, setAudit ] = useState(null);
	let { token } = useParams();
	const notes = useRef(null);
	
	const themeModeContext = useContext(ThemeModeContext);
	const imageUrls = {
		"light": "/cymplify-logo_light.png",
		"dark": "/cymplify-logo_dark.png",
	}
	const imageUrl = imageUrls[themeModeContext.themeMode];
	
	useEffect(async () => {
		try {
			const data = await policyService.getAuditPolicy(token);
			const usecureData = JSON.parse(data.policy.usecure_data);
			setUsecurePolicyData(JSON.parse(data.policy.usecure_data));
			setAudit(data.audit);
			setPolicy(data.policy);
		}
		catch (e) {
			console.log(`Error getting audit: ${e.message}`);
		}
	}, []);
	
	const formControlStyle = {
		width: "80%",
		maxWidth: "35em",
		margin: "1em auto",
		display: "flex",
		lexDirection: "row",
		flexGrow: 1
	};
	
	const handleDownloadClick = async () => {
		await policyService.downloadAuditPolicy(token, policy);
	};
	
	const handleFeedbackClick = async () => {
		const notesValue = notes.current.value;
		await policyService.setAuditFeedback(token, notes.current.value);
		alertService.show("Feedback submitted successfully.");
	};
	
	return (
		<Box sx={{ display: "flex" }}>
			<Box component="main" sx={{flexGrow: 1, bgcolor: "background.default"}}>
				<Box sx={contentBoxStyle}>
					<Box sx={{
						height: "40em",
						width: "25em",
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)"
					}}>
						<Box sx={{ textAlign: "center", marginBottom: "3em" }}>
							<Link to="/">
								<img src={imageUrl} alt="cymplify logo" />
							</Link>
						</Box>
						{ policy?
						<Stack direction="column" spacing="2em">
							<Stack direction="column" spacing="1em">
								<Typography sx={{ fontWeight: "bold" }}>Policy Audit</Typography>
								<Typography>{`Name: ${policy.name}`}</Typography>
								<Typography>
									{`Published: ${format(
										new Date(usecurePolicyData.documents[0].publishedAt),
										"dd/MM/yyyy"
									)}`}
								</Typography>
								<Button label="Download policy" onClick={handleDownloadClick}>Download</Button>
							</Stack>
							<Stack direction="column" spacing="1em">
								<Typography>Feedback:</Typography>
								<TextareaAutosize minRows="16" style={{ width: "100%" }} ref={notes} defaultValue={audit.notes}/>
								<Button label="Submit notes" onClick={handleFeedbackClick}>Submit Feedback</Button>
							</Stack>
						</Stack>
						:
						<Box sx={{ textAlign: "center" }}>
							<CircularProgress/>
						</Box>
						}
					</Box>
				</Box>
			</Box>
		</Box>
	);

}

export default PolicyAudit;